'use client';

import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { getInteriorSwatchStyle, type InteriorSwatchColor } from '@/app/lcv/components/shared/color-list/utils';
import { cn } from '@/app/utils/cn';
type InteriorColorSwatchFaceProps = {
  interiorColor?: InteriorSwatchColor | null;
  fallbackColor?: string;
  className?: string;
};

/** Paint chip face: CMS base + Figma radial sheen (rotated SVG, plus-lighter). */
export const InteriorColorSwatchFace = t0 => {
  const $ = _c(24);
  const {
    interiorColor,
    fallbackColor,
    className
  } = t0;
  const t1 = useId();
  let t2;
  if ($[0] !== t1) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /:/g;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    t2 = t1.replace(t3, "");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const gradientId = `interior-sheen-${t2}`;
  let t3;
  if ($[3] !== fallbackColor || $[4] !== interiorColor) {
    t3 = getInteriorSwatchStyle(interiorColor, fallbackColor);
    $[3] = fallbackColor;
    $[4] = interiorColor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const baseStyle = t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("relative block size-full overflow-hidden rounded-sm", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== baseStyle) {
    t5 = <span className="absolute inset-0" style={baseStyle} />;
    $[8] = baseStyle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `url(#${gradientId})`;
  let t7;
  if ($[10] !== t6) {
    t7 = <path d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z" fill={t6} fillOpacity={0.2} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <stop stopColor="white" />;
    t9 = <stop offset="0.5" stopColor="white" stopOpacity="0" />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== gradientId) {
    t10 = <defs><radialGradient id={gradientId} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1.5 1) rotate(45.3696) scale(54.8019)">{t8}{t9}</radialGradient></defs>;
    $[14] = gradientId;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7) {
    t11 = <svg className="pointer-events-none absolute inset-0 size-full mix-blend-plus-lighter" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t7}{t10}</svg>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="pointer-events-none absolute inset-0 rounded-sm shadow-[inset_0_0_0_1px_rgba(15,23,42,0.12)]" aria-hidden="true" />;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t4 || $[22] !== t5) {
    t13 = <span aria-hidden="true" className={t4}>{t5}{t11}{t12}</span>;
    $[20] = t11;
    $[21] = t4;
    $[22] = t5;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};